var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-13dv1ez" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: 5px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: 5px;\n  }\n"])));
export var StatusHeaderCell = function () {
    return _jsx(ScCell, { children: "Status" }, void 0);
};
var templateObject_1;
